import { render, staticRenderFns } from "./TaskPlanning.vue?vue&type=template&id=233b70c6&"
import script from "./TaskPlanning.vue?vue&type=script&lang=js&"
export * from "./TaskPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports